/**
 * Static feature flags.
 *
 * There is no remote flag provider yet, so this table IS the provider: flip a
 * value here and every gated surface switches on the next build. Keys are
 * kebab-case so they can later map 1:1 onto a provider's flag names, and
 * `isFeatureEnabled` takes the table as a parameter so a future provider only
 * has to hand over its resolved table.
 */
export type FeatureFlag = 'email-credentials-auth' | 'telegram-linking';

export const FEATURE_FLAGS: Record<FeatureFlag, boolean> = {
  // Email + password sign-in / sign-up. Off ⇒ Login and Signup offer only the
  // social providers (Google, Facebook, LinkedIn).
  'email-credentials-auth': false,
  // Telegram account linking. Off ⇒ the connect card, the Channels section and
  // the setup step all disappear, and no /telegram/* request is made. Stays off
  // until the Module 2 routes are on the backend; a deployed build would
  // otherwise offer a link that can only fail.
  'telegram-linking': false,
};

/** True when `flag` is switched on in `flags` (defaults to the static table). */
export function isFeatureEnabled(
  flag: FeatureFlag,
  flags: Partial<Record<FeatureFlag, boolean>> = FEATURE_FLAGS
): boolean {
  return flags[flag] ?? false;
}
